import { shopCall } from '../shop-shared/transport';
import type { CheckoutQuoteResult, ProcessCheckoutResult, ShopCheckoutInitData } from './types';

export function getCheckoutData(init: ShopCheckoutInitData): Promise<Partial<ShopCheckoutInitData>> {
    return shopCall<Partial<ShopCheckoutInitData>>(init, 'gas_get_checkout_data', {});
}

export function processCheckout(
    init: ShopCheckoutInitData,
    payload: Record<string, unknown>,
): Promise<ProcessCheckoutResult> {
    return shopCall<ProcessCheckoutResult>(init, 'gas_process_checkout', payload);
}

/**
 * Quote live checkout (D6) — POST /gas/v1/shop/checkout/quote.
 * Non autoritaire : le serveur re-quote à la soumission.
 */
export function quoteCheckout(
    init: ShopCheckoutInitData,
    payload: {
        country?: string;
        method?: string;
        billing_country?: string;
        shipping_country?: string;
        sequence?: number;
    },
    signal?: AbortSignal,
): Promise<CheckoutQuoteResult> {
    return shopCall<CheckoutQuoteResult>(init, 'gas_shop_checkout_quote', payload, signal);
}
